import { render, staticRenderFns } from "./ReAllocateToTopAgent.vue?vue&type=template&id=3fab7ba7&scoped=true&"
import script from "./ReAllocateToTopAgent.vue?vue&type=script&lang=js&"
export * from "./ReAllocateToTopAgent.vue?vue&type=script&lang=js&"
import style0 from "./ReAllocateToTopAgent.vue?vue&type=style&index=0&id=3fab7ba7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fab7ba7",
  null
  
)

export default component.exports